var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('AjaxTable',{attrs:{"endpoint":"user","headline":"Benutzer","searchFilterId":"user","displayFields":_vm.displayFields,"fieldKinds":[],"popups":_vm.popups,"queryFields":_vm.queryFields,"initialHeader":_vm.initialHeader}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }